// ====================================================
// src/components/block/liveStreamManagement/enchainements/registry.ts
//
// Un seul point d'inscription : pour ajouter un enchaînement au T-bar,
// créer sa classe (cf. FonduEnchainement.ts pour le modèle) et l'ajouter ici.
// ====================================================

import { Enchainement } from './Enchainement';
import { fonduEnchainement } from './FonduEnchainement';
import { pousseEnchainement } from './PousseEnchainement';
import { recouvrementEnchainement } from './RecouvrementEnchainement';
import { voletEnchainement } from './VoletEnchainement';
import { irisEnchainement } from './IrisEnchainement';
import { zoomEnchainement } from './ZoomEnchainement';
import { flashEnchainement } from './FlashEnchainement';
import { storeVenitienEnchainement } from './StoreVenitienEnchainement';
import { horlogeEnchainement } from './HorlogeEnchainement';
import { damierEnchainement } from './DamierEnchainement';

export const ENCHAINEMENTS: Enchainement<any>[] = [
  fonduEnchainement,
  pousseEnchainement,
  recouvrementEnchainement,
  voletEnchainement,
  irisEnchainement,
  zoomEnchainement,
  flashEnchainement,
  storeVenitienEnchainement,
  horlogeEnchainement,
  damierEnchainement,
];

export const getEnchainementById = (id: string): Enchainement<any> =>
  ENCHAINEMENTS.find(e => e.id === id) ?? fonduEnchainement;
